import React from 'react';
import Container from '@material-ui/core/Container';
import { withStyles } from '@material-ui/core';
import { trackPage } from '../../utilities/analyticsUtilities';
import IndexHeadSection from '../components/index/IndexHeadSection';
import IndexScreenshotSection from '../components/index/IndexScreenshotSection';
import IndexCloudFeaturesSection from '../components/index/IndexCloudFeaturesSection';
import IndexExamplesSection from '../components/index/IndexExamplesSection';
import IndexSuccessSection from '../components/index/IndexSuccessSection';
import IndexEndSection from '../components/index/IndexEndSection';
import Helmet from 'react-helmet';

const styles = theme => ({
});

class Index extends React.Component {
	render() {
		const { classes } = this.props;

		return (
			<Container maxWidth='lg'>
				<Helmet>
					<title>Specterr | Music Video Maker Online</title>
					<meta 
						name='description' 
						content='Easily create music visualizers and lyric videos online. Make your first video for free. It only takes a couple minutes.'
					></meta>
					<link rel='canonical' href='https://specterr.com' />
				</Helmet>
				<IndexHeadSection />
				<IndexScreenshotSection />
				<IndexExamplesSection/>
				<IndexCloudFeaturesSection />
				<IndexSuccessSection/>
				<IndexEndSection />
			</Container>
		);
	}

	componentDidMount() {
		trackPage('/');
	}
}

export default withStyles(styles)(Index);